import React from "react";
import {
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="footer clearfix"
      data-overlay-darkgray="8"
      style={{
        margin: "0", // Supprime les marges externes
        padding: "0", // Supprime les padding internes
        backgroundColor: "#000", // S'assure que le fond reste noir
      }}
    >
      <div className="container">
        <div className="second-footer">
          <div className="row">
            <div className="col-md-12 widget-area">
              <div className="widget clearfix">
                <div className="widget-text">
                  <p>
                    Chez Jacob Production, nous révélons votre histoire à
                    travers des images percutantes et authentiques. De la
                    captation à la diffusion, nous sublimons chaque instant pour
                    renforcer votre présence et marquer les esprits.
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 widget-area">
              <div className="widget clearfix usful-links">
                <h3 className="widget-title">Photographie</h3>
                <ul>
                  <li>
                    <a href="/photo/reportage">Reportage</a>
                  </li>
                  <li>
                    <a href="/photo/portrait">Portrait</a>
                  </li>
                  <li>
                    <a href="/photo/evenementiel">Événementiel</a>
                  </li>
                  <li>
                    <a href="/photo/industriel">Industriel</a>
                  </li>
                  <li>
                    <a href="/photo/packshot">Packshot</a>
                  </li>
                  <li>
                    <a href="/photo/mariage">Mariage</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4 widget-area">
              <div className="widget clearfix usful-links">
                <h3 className="widget-title">Liens rapides</h3>
                <ul>
                  <li>
                    <a href="/aPropos">À propos de nous</a>
                  </li>
                  <li>
                    <a href="/rea">Réalisations</a>
                  </li>
                  <li>
                    <a href="/contact">Contact</a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-md-4 widget-area">
              <div className="widget clearfix">
                <h3 className="widget-title">Contact</h3>
                <div className="featured-icon-box icon-align-before-content icon-ver_align-top style1">
                  <div className="featured-icon">
                    <FaPhone className="icon" style={{ color: "#fff" }} />
                  </div>
                  <div className="featured-content">
                    <div className="featured-desc">
                      <p>
                        <a
                          href="tel:0649735256"
                          style={{ color: "#fff", textDecoration: "none" }}
                        >
                          06.49.73.52.56
                        </a>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="featured-icon-box icon-align-before-content icon-ver_align-top style1">
                  <div className="featured-icon">
                    <FaEnvelope className="icon" style={{ color: "#fff" }} />
                  </div>
                  <div className="featured-content">
                    <div className="featured-desc">
                      <p>
                        <a
                          href="mailto:contact.jacobproduction@gmail.com"
                          style={{ color: "#fff", textDecoration: "none" }}
                        >
                          contact.jacobproduction@gmail.com
                        </a>
                      </p>
                    </div>
                  </div>
                </div>

                <div className="featured-icon-box icon-align-before-content icon-ver_align-top style1">
                  <div className="featured-icon">
                    <FaMapMarkerAlt
                      className="icon"
                      style={{ color: "#fff" }}
                    />
                  </div>
                  <div className="featured-content">
                    <div className="featured-desc text-white">
                      <p> 33 rue Vineuse 75116, Paris</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bottom-footer-text">
          <div className="row copyright">
            <div className="col-md-8">
              <p className="mb-0">
                Copyright ©{" "}
                {currentYear === 2024 ? "2024" : `2024 - ${currentYear}`} par{" "}
                <a>JacobProduction,</a>
                <br /> Tous droits réservés.
              </p>
            </div>
            <div className="col-md-4">
              <div className="social-icons">
                <ul className="list-inline">
                  <li>
                    <a
                      href="https://www.instagram.com/jacobproduction_studio/"
                      target="_BLANK"
                    >
                      <FaInstagram style={{ color: "#fff" }} />
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/in/jacob-production-bba672345?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app"
                      target="_BLANK"
                    >
                      <FaLinkedinIn style={{ color: "#fff" }} />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
